import React from "react";
import styled from "styled-components";
import { Chip, Icon } from "@material-ui/core";

const TagList = styled.div`
    width: 100%;

    .MuiChip-root {
        height: 26px;
        margin-right: 6px;
        margin-bottom: 4px;
        margin-top: 4px;
        font-size: 13px;
        font-weight: 500;
        align-items: center;
    }

    .MuiChip-label {
        padding-left: 10px;
        padding-right: 10px;
        line-height: 26px;
    }

    .MuiChip-deleteIcon {
        width: 13px;
        height: 13px;
        margin: 0 7px 0 -3px;
        color: #777;
        align-self: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        line-height: 1;
        cursor: pointer;
    }

    .MuiChip-colorPrimary {
        font-size: 12px;
        font-weight: 600;
        text-transform: none;
        transition: background-color 120ms ease;
    }

    .MuiChip-colorPrimary:hover,
    .MuiChip-colorPrimary:focus {
        background-color: #0c98cf;
    }

    .MuiChip-colorPrimary .MuiChip-label {
        padding-right: 12px;
    }

    .MuiChip-icon {
        width: 15px;
        height: 15px;
        margin-left: 9px;
        margin-right: 0;
        overflow: visible;
        align-self: center;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        line-height: 1;
    }
`;

export default function TagsList({ tags, onRemove, onClick }) {
    return (
        <TagList>
            {tags.map((tag, i) => (
                <Chip
                    clickable
                    key={i}
                    color="default"
                    label={tag}
                    onDelete={() => onRemove(tag)}
                    deleteIcon={<Icon fontSize="inherit">close</Icon>}
                />
            ))}
            <Chip
                icon={<Icon fontSize="inherit">add_circle</Icon>}
                color="primary"
                label="Add tag"
                onClick={onClick}
                style={{ color: "white" }}
            />
        </TagList>
    );
}
